import { Gift } from 'lucide-react';
import type { PluginDefinition } from '../types';
import { LoyaltyConfigComponent, type LoyaltyConfig } from './ConfigComponent';
import { LoyaltyPageComponent } from './PageComponent';

export const loyaltyPlugin: PluginDefinition<LoyaltyConfig> = {
  slug: 'fidelidade',
  icon: Gift,
  navLabel: 'Fidelidade',
  navIcon: Gift,
  navPath: '/fidelidade',
  defaultConfig: {
    points_per_real: 1,
    minimum_sale_value: 0,
  },
  ConfigComponent: LoyaltyConfigComponent,
  PageComponent: LoyaltyPageComponent,
};

export { LoyaltyPageComponent };
export type { LoyaltyConfig };
